import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, inject, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';

import { PipeModule } from '@shared/pipe/pipe.module';
import { PrimeNgModule } from '@shared/prime-ng/prime-ng.module';

@Component({
    selector: 'app-show-more-html',
    imports: [
    PipeModule,
    PrimeNgModule
],
    templateUrl: './show-more-html.component.html',
    styleUrls: ['./show-more-html.component.scss']
})
export class ShowMoreHtmlComponent implements AfterViewInit, OnDestroy {
  @Input() html = ''; // Accept dynamic content
  @Input() expandEvent
  @ViewChild('contentContainer') contentContainer!: ElementRef;

  cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  isCollapsed = true;
  isOverflowing = false;

  private resizeObserver!: ResizeObserver;

  ngAfterViewInit() {
    const contentElement = this.contentContainer.nativeElement;

    this.resizeObserver = new ResizeObserver(() => {
      this.isOverflowing = contentElement.scrollHeight > 150;
      this.cdr.detectChanges();
    });

    this.resizeObserver.observe(contentElement);
  }

  toggleContent() {
    this.isCollapsed = !this.isCollapsed;
  }

  ngOnDestroy() {
  if (this.resizeObserver) {
    this.resizeObserver.disconnect();
  }
}
}
